module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phrase":"Awards powered by Swiset","description":"An award winning trading app. Journal, Tournaments and Prop Simulations"},"es":{"phrase":"Premios traídos a ti por Swiset","description":"Una suite de trading premiada. Journal, Torneos y Simulaciones de Prop"}}')
  delete Component.options._Ctor
}
